import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { INavigateCollectionTriageClipV3Request } from './navigate-collection-triage-clip-v3-request';
import type { INavigateCollectionTriageClipV3Response } from './navigate-collection-triage-clip-v3-response';
import { navigateCollectionTriageClipV3ResponseSchema } from './navigate-collection-triage-clip-v3-response';

export async function navigateCollectionTriageClipV3Api({
  collectionId,
  clipId,
  direction,
}: INavigateCollectionTriageClipV3Request): Promise<
  IValidatedResponse<INavigateCollectionTriageClipV3Response>
> {
  return getRequest<INavigateCollectionTriageClipV3Response>({
    path: `/sys/collections/${collectionId}/triage/navigate/v3?clipId=${clipId}&direction=${direction}`,
    schema: navigateCollectionTriageClipV3ResponseSchema,
  });
}
